module.exports = __webpack_public_path__ + "img/icon-preview-1.59d3e1c0.svg";